<script lang="ts">
  import moment from "moment";
  import T from "../texts";
  import type { TicketEventOrderPreview } from "../../../types/ticket";
  import { getShopifyProductThumbnail } from "../../../lib";
  import ShopifyLogo from "../ShopifyLogo.svelte";
  import { displayInCurrency } from "../../../lib/currency";

  export let s;
  export let orderPreview: TicketEventOrderPreview;
  export let language;
  export let currency;
  export let accountId;
</script>

<a
  href={orderPreview.external_status_url}
  class={s.orderPreviewWrapper}
  target="_blank"
>
  <div>
    <ShopifyLogo />
    <span class={s.orderPreviewName}>
      Order {orderPreview.name}
    </span>
  </div>
  <div class={s.orderByline}>
    {displayInCurrency(orderPreview.total_amount, currency)}
    <span class={s.interpunct}>·</span>
    <span data-datetime={orderPreview.created_at}
      >{moment(orderPreview.created_at).fromNow()}</span
    >
  </div>
  <div class={s.orderPreviewDivider}>&nbsp;</div>
  <div>
    {#each orderPreview.line_items as line_item}
      <div class={s.orderPreviewLineItem}>
        <div class={s.lineItemLeft}>
          <img
            class={s.lineItemImage}
            src={getShopifyProductThumbnail(
              accountId,
              line_item.product_id,
              line_item.variant_id || '',
            )}
            alt="product"
          />
          <div class={s.lineItemQuantity}>
            {line_item.quantity}
          </div>
        </div>
        <div>
          <div class={s.lineItemName}>
            {line_item.name}
          </div>
          {#if line_item.refunded_quantity !== undefined && line_item.refunded_quantity > 0}
            <div class={s.lineItemRefund}>
              {T(language, "Refunded: {0}", [line_item.refunded_quantity?.toString() || '0'])}
            </div>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</a>
